var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Water Award") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Water-Award"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 12.000000)",
    fill: "#296EC6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.85738826,30.35562 C4.27343228,35.9553123 10.44889,39.9371681 17.6857525,39.9371681 C21.7867688,39.9371681 25.5469351,38.6584704 28.4752678,36.531279 L28.4907846,36.5346423 C32.5710274,33.9706703 34.8158986,30.6623874 35.2253984,26.6097933 C35.4539333,24.3481094 34.9493389,21.4668874 33.7313337,19.2443036 C32.2351584,16.5141225 30.1354967,14.4794859 29.8474646,14.2107819 C25.4966033,10.1518813 24.7555188,9.88283659 23.8309008,7.8316135 C23.3684428,6.80567166 23.2537074,5.92104986 23.1542903,4.89196463 C23.0517123,3.83016059 23.3749145,2.19950571 24.1238968,0 C20.0231796,1.5975124 17.1791062,2.82194576 15.5916767,3.67330007 C11.854216,5.67773762 9.29122676,7.88683269 7.5227015,9.46073513 C5.72523028,11.0603981 3.27425128,13.3158302 2.00913049,15.9038086 C1.61820301,16.7035045 -0.0789267568,19.1225586 0.0028587016,23.42648 C0.0479705513,25.80047 0.666147069,28.1101833 1.85738826,30.35562 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.05,
    fill: "#296EC6",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#296EC6",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 8
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterAward);
export default __webpack_public_path__ + "static/media/Water Award.1ea688a67e7c400786387b61bb28c9f6.svg";
export { ForwardRef as ReactComponent };